import { useCallback, useContext } from "react";
import { useParams } from "react-router-dom";

import { CardItemStyled, CardTitle, KMdText700PrimaryBase, KMdTextSecondary65 } from "@components";
import { KContext } from "@context";
import { useCustomNavigate } from "@hooks";
import { ECardType, IItemCardProps, IParams, ITestResults } from "@types";
import { formatDate } from "@utils/date";
import { CardItemContainer } from "../share-component";
import { getInfoCard } from "@utils/cardTypeIcon";

export const TestResultsItem = ({ card, isDetail, showMetadata, showIcon }: IItemCardProps<ITestResults>) => {
  const {
    _id,
    title,
    startTime,
    provider,
    cardType
  } = card;
  const { cardId } = useParams<IParams>();
  const { navigate } = useCustomNavigate();
  const { setCardTypeSelected, navigateDetailCard } = useContext(KContext);

  const iconCardType = showIcon && getInfoCard(cardType).icon;


  const onClickItem = useCallback(() => {
    if (cardId === _id) return;
    if (!isDetail) {
      return navigate(
        _id,
        undefined,
        () => { setCardTypeSelected(ECardType.TestResults); },
      );
    }
    navigateDetailCard(ECardType.TestResults, _id);
  }, [_id, cardId]);

  return (
    <CardItemStyled $isActive={cardId === _id} onClick={onClickItem}>
      <CardItemContainer showMetadata={showMetadata} card={card} gap={4}>
        <CardTitle
          icon={iconCardType}
        >
          {title}
        </CardTitle>
        {startTime && (
          <KMdTextSecondary65>
            {formatDate(startTime, "FULL_MONTH_YEAR")}
          </KMdTextSecondary65>
        )}
        <KMdText700PrimaryBase>
          {provider}
        </KMdText700PrimaryBase>
      </CardItemContainer>
    </CardItemStyled>
  );
};
